// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import initPosthog from '@/utils/initPosthog'
initPosthog()


import setupCSRFToken from '@/utils/setupCSRFToken'
document.addEventListener('DOMContentLoaded', function () {
 setupCSRFToken()
});

import globalStore from '@/stores/global.svelte'
globalStore.fetchCurrentAccountAndUser()

import '../src/apps/birthdays/edit'
import '../src/apps/contact_imports/index'
import '../src/apps/coupons/form'
import '../src/apps/coupons/public'
import '../src/apps/keywords/index'
import '../src/apps/keywords/edit'
import '../src/apps/launchpad/modal'
import '../src/apps/users/edit/profile_photo_form'
import '../src/apps/messages/upload_images'
import '../src/apps/superadmin/message-list'
import '../src/apps/draft-review/index'
import '../src/apps/drafts-list/index'
import '../src/apps/triggers/index'
